.richtext {
  @at-root {
    h2#{&} {
      margin-bottom: 1.5rem;
    }
    h3#{&} {
      margin-bottom: 1rem;
    }
    h4#{&},
    h5#{&} {
      margin-bottom: 0.5rem;
    }

    * + h2#{&} {
      margin-top: 3rem;
    }

    * + h3#{&},
    * + h4#{&},
    * + h5#{&},
    * + h6#{&} {
      margin-top: 2rem;
    }
  }
}
